<template>
    <div style="width: 100%;">
        <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
            <div>
                <div v-if="is_logistics == 1">
					<el-button type="primary" @click="downloadTempFile()">
					    导出发货信息模板
					</el-button>
                    <el-button type="primary" @click="dialogVisible = true">
                        导入发货信息
                        <el-tooltip width="500" content="说明：模板导入最多支持200条数据，“导入发货信息”文本格式仅支持.xls .xlsx格式，导入模板首行表头禁止删除，需按照“订单编号、快递公司、快递单号”顺序排列，所填快递公司需参考模板快递编码填写，请确保快递单号与快递编码对应，避免单号有误查询不到物流信息。导入失败信息会生成失败文档，在文档尾列展示失败原因，请修改后重新提交。" placement="top">
                            <i class="el-icon-upload el-icon--right"></i>
                        </el-tooltip>
                    </el-button>
                </div>
            </div>
            <span @click="upImportList" style="color:rgb(25, 137, 250);cursor:pointer">导入记录></span>
        </div>

        <el-dialog title="导入文件" :visible.sync="dialogVisible" center width="500px">
            <div style="width: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column;">
                <div style="margin-bottom: 20px;" v-if="dialogVisible">
					<el-upload ref="fileUplod" drag :limit=limitNum :auto-upload="false" accept=".xls,.xlsx" :action="UploadUrl()"
					    :before-upload="beforeUploadFile" :on-change="fileChange" :on-exceed="exceedFile"
					    :on-success="handleSuccess" :on-error="handleError" :file-list="fileList">
					    <i class="el-icon-upload"></i>
					    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					    <div class="el-upload__tip" slot="tip">只能上传xls,xlsx文件，且不超过100kb，一次最多只能导入500条数据</div>
					</el-upload>
				</div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" type="primary" @click="uploadFile">立即上传</el-button>
                    <el-button @click="dialogVisible = false" size="small">取消</el-button>
                </span>
            </div>
        </el-dialog>

        <el-dialog title="导入记录" :visible.sync="dialogListKey" width="720px">
            <el-table :data="gridData.list" v-loading="tableLoading">
                <el-table-column property="status_name" label="导入状态" width="150"></el-table-column>
                <el-table-column label="导入/成功/失败（个数）" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.count }}/{{ scope.row.success }}/{{ scope.row.fail }}</span>
                    </template>
                </el-table-column>
                <el-table-column property="created_time" label="导入时间" width="180"></el-table-column>
                <el-table-column label="操作"  width="150">
                    <template slot-scope="scope">
                        <span v-if="[2,4].includes(scope.row.status)" @click="exportExcel(scope.row.id)"
                            style="color: rgb(25, 137, 250);cursor: pointer;font-size: 12px;">下载失败记录</span>
                    </template>
                </el-table-column>
            </el-table>
			<Pagination @change="changeSize" :total="gridData.total" ref="pagination" v-if="Math.ceil(gridData.total / queryInfo.page_size) > 1" v-model="queryInfo.page" />
        </el-dialog>
    </div>
</template>
  
<script>
import axios from 'axios'
import staticPathTitle, { getBaseUrl } from '@/utils/baseUrl.js'
import {
    mapActions
} from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
export default {
    data() {
        return {
            dialogVisible: false,   // 控制弹窗显示隐藏
            dialogListKey: false,
            limitNum: 1,  // 上传excell时，同时允许上传的最大数
            fileList: [],   // excel文件列表
            gridData:{
                total:0,
                list:[]
            },
            queryInfo:{
                page:1,
                page_size:10
            },
            tableLoading:false
        }
    },
    props: ['is_logistics'],
    components:{
        Pagination
    },
    methods: {
        ...mapActions('withdrawal', ['logistics_import_index']),
        exportExcel(id) {
            let token = localStorage.getItem('token')
            const comeFrom = staticPathTitle[this.staticPath].value
            window.open(getBaseUrl() + '/user/order/logistics_fail?token=' + encodeURIComponent(token) + '&excel=1&comeFrom=' + comeFrom + '&id=' + id)
        },
        async upImportList() {
            if(!this.dialogListKey){
                this.queryInfo.page=1
                this.dialogListKey = true
            }
            this.tableLoading = true
            let {count,data} = await this.logistics_import_index(this.queryInfo)
            this.gridData = {
                total:count,
                list:data
            }
            this.tableLoading = false
        },
        // 文件超出个数限制时的钩子
        exceedFile(files, fileList) {
            this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`);
        },
        // 文件状态改变时的钩子
        fileChange(file, fileList) {
            console.log(file.raw);
            this.fileList.push(file.raw);
            console.log(this.fileList);
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {
            console.log('before upload');
            console.log(file);
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let size = file.size / 1024 / 1024;
            const fileTypes = ['xls','xlsx']
            if (!fileTypes.includes(extension)) {
                this.$message.warning('只能上传后缀是.xls,.xlsx的文件');
            }
            if (size > 10) {
                this.$message.warning('文件大小不得超过10M');
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file, fileList) {
            this.$message.success('文件上传成功');
        },
        // 文件上传失败时的钩子
        handleError(err, file, fileList) {
            this.$message.error('文件上传失败');
        },
        UploadUrl: function () {
            // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
            return ""
        },
        uploadFile() {
            if (this.fileList.length === 0) {
                this.$message.warning('请上传文件');
            } else {
                let form = new FormData();
                form.append('file', this.fileList[0]);
                axios({
                    method: "post",
                    url: "/user/order/logistics_import",
                    headers: {
                        'Content-type': 'multipart/form-data'
                    },
                    data: form
                }).then(res => {
                    console.log(res, 'ooo')
                    const {message,code} = res.data
                    if (code === 0) {
                        this.$message.success(message || '上传成功');
						this.fileList = []
						this.$refs.fileUplod.clearFiles()
                        this.dialogVisible = false
                    } else {
                        this.$message.error(message || '上传失败');
                    }
                }).catch((error) => {

                })
            }
        },
		downloadTempFile(){
			const link = document.createElement('a')
			link.style.display = 'none';
			link.href = `/xlsx/发货信息导入模板.xlsx`
			link.setAttribute('target', '_blank')
			link.download = decodeURIComponent('发货信息导入模板') +  '.xlsx'
			link.click()
		},
        changeSize(size) {
            this.queryInfo.page=size
            this.upImportList()
        },
    }
}
</script>
  
<style>
.el-tooltip__popper {
    max-width: 400px;
}
</style>
  
  